import type { DisciplineBalancesStore } from './interfaces'

export const getters = {
  isLoading: (state: DisciplineBalancesStore): DisciplineBalancesStore['loading'] => state.loading,
  getBalances: (state: DisciplineBalancesStore): DisciplineBalancesStore['balances'] => state.balances,
  hasBalances: (state: DisciplineBalancesStore): boolean => state.balances.length > 0,
  getMeta: (state: DisciplineBalancesStore): DisciplineBalancesStore['meta'] => state.meta,
  getFilters: (state: DisciplineBalancesStore): DisciplineBalancesStore['filters'] => state.filters,
  hasFilters: (state: DisciplineBalancesStore): boolean =>
    state.filters.reasons.length > 0 || !!state.filters.responsible,
  getCurrentPage: (state: DisciplineBalancesStore): DisciplineBalancesStore['currentPage'] => state.currentPage,
  getPerPage: (state: DisciplineBalancesStore): DisciplineBalancesStore['perPage'] => state.perPage,
  isModalOpen: (state: DisciplineBalancesStore): DisciplineBalancesStore['modalOpen'] => state.modalOpen,
}
